<template>
  <div class="top_bg colof">
    <div class="font18 font_weight500 line_height_24">
      配送频率：2瓶/周，发完即止
    </div>
    <div class="font14 font_weight400 line_height_20 det_det">
      选择日期为预计发货时间，实际发货时间可能随供应链调整改变
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.top_bg {
  background: linear-gradient(360deg, #bf9264 0%, #d6b99b 100%);
  box-shadow: 0px 6px 6px -3px #c4ae98, 0px 1px 2px 0px rgba(255, 255, 255, 0.5),
    0px -1px 3px 0px rgba(255, 255, 255, 0.5);
  border-radius: 8px;
  padding: 20px 10px;
  .det_det {
    padding-top: 10px;
  }
}
</style>
